module.exports = __webpack_public_path__ + "static/media/link-btn@2x.ec0b1822.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/link-btn@2x.png
// module id = 833
// module chunks = 0